const STORAGE_KEY_WebPortalBaseUrl = "webPortalBaseUrl";
const STORAGE_KEY_CoreBaseUrl = "coreBaseUrl";
const STORAGE_KEY_MarketingBaseUrl = "marketingBaseUrl";
const STORAGE_KEY_PinTaskpaneHintClosed: string = "PinTaskpaneHint-closed";
const STORAGE_KEY_PinTaskpaneHintDisplayCount: string = "PinTaskpaneHint-count";
const STORAGE_KEY_OverrideUsername = "overrideUsername";

export default class Config {

    public static clearAll() {
        
        window.localStorage.removeItem(STORAGE_KEY_WebPortalBaseUrl);
        window.localStorage.removeItem(STORAGE_KEY_CoreBaseUrl);
        window.localStorage.removeItem(STORAGE_KEY_MarketingBaseUrl);
        window.localStorage.removeItem(STORAGE_KEY_PinTaskpaneHintClosed);
        window.localStorage.removeItem(STORAGE_KEY_PinTaskpaneHintDisplayCount);
        window.localStorage.removeItem(STORAGE_KEY_OverrideUsername);
    }

    ///////
    public static getWebPortalBaseUrl(): string {
        var value = window.localStorage.getItem(STORAGE_KEY_WebPortalBaseUrl);
        if (value == null) {
            return "https://app.protectedtrust.com";
        }
        else {
            return value;
        }
    }

    public static setWebPortalBaseUrl(value: string) {
        window.localStorage.setItem(STORAGE_KEY_WebPortalBaseUrl, value);
    }

    /////////
    public static getCoreBaseUrl(): string {
        var value = window.localStorage.getItem(STORAGE_KEY_CoreBaseUrl);
        if (value == null) {
            return "https://ws.protectedtrust.com";
        }
        else {
            return value;
        }
    }

    public static setCoreBaseUrl(value: string) {
        window.localStorage.setItem(STORAGE_KEY_CoreBaseUrl, value);
    }

     /////////
    public static getMarketingBaseUrl(): string {
        var value = window.localStorage.getItem(STORAGE_KEY_MarketingBaseUrl);
        if (value == null) {
            return "https://www.protectedtrust.com";
        }
        else {
            return value;
        }
    }

    public static setMarketingBaseUrl(value: string) {
        window.localStorage.setItem(STORAGE_KEY_MarketingBaseUrl, value);
    }

    /////////
    public static getPinTaskpaneHintClosed(): boolean {
        return window.localStorage.getItem(STORAGE_KEY_PinTaskpaneHintClosed) == "true";
    }

    public static setPinTaskpaneHintClosed(value: boolean) {
        window.localStorage.setItem(STORAGE_KEY_PinTaskpaneHintClosed, value ? "true" : "false");
    }

    //////////
    public static getPinTaskpaneHintDisplayCount(): number {
        return parseInt(window.localStorage.getItem(STORAGE_KEY_PinTaskpaneHintDisplayCount) || "0");
    }

    public static setPinTaskpaneHintDisplayCount(value: number) {
        window.localStorage.setItem(STORAGE_KEY_PinTaskpaneHintDisplayCount, value + "");
    }

    /////////
    public static getOverrideUsername(): string {
        var val: string = window.localStorage.getItem(STORAGE_KEY_OverrideUsername);
        if (val && val.length == 0) {
            return null;
        }
        else {
            return val;
        }
    }

    public static setOverrideUsername(value: string) {
        window.localStorage.setItem(STORAGE_KEY_OverrideUsername, value);
    }
}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/Config.ts